var _line, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartG(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 68,
    viewBox: "0 0 65 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.23925,
    y1: 40.1699,
    x2: 64.1416,
    y2: 40.1699,
    stroke: "#828282",
    strokeWidth: 1.09765,
    strokeLinecap: "round",
    strokeDasharray: "2.2 2.2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9102 39.4621C11.799 28.6787 13.7102 6.85317 14.2435 5.81796C15.3546 2.79862 18.2435 -1.29906 20.9102 6.46496C21.3546 7.75899 22.5102 17.8523 23.5768 47.8732C23.799 49.5985 24.7768 52.661 26.9102 51.1082C28.2435 49.5985 31.0435 48.779 31.5768 57.5782C31.799 62.7542 33.3102 70.9065 37.5768 62.1072C39.5768 54.9902 43.7102 40.4972 44.2435 39.4621C45.3546 37.5211 48.5102 35.0625 52.2435 40.7562C52.9102 41.4031 54.6435 42.05 56.2435 39.4621",
    stroke: "#66FCF1",
    strokeWidth: 2.43518,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartG);
export default __webpack_public_path__ + "static/media/chartG.411821d38338f92af76034a7d4a1ae3d.svg";
export { ForwardRef as ReactComponent };